<template>
  <div :class="$style.links">
    <ul>
      <li v-for="({ label, ...link }) in links">
        <Link v-bind="link">
          {{ label }}
        </Link>
      </li>
    </ul>
  </div>
</template>

<script>
import Link from '@/components/Link'

export default {
  components: {
    Link,
  },
  props: {
    links: {
      type: Array,
      default: [],
    },
  },
}
</script>

<style lang="scss" module>
.links {
  @apply mt-12;

  ul {
    @apply list-none;
    @apply m-0;
    @apply p-0;
    @apply flex;
    @apply flex-wrap;
    @apply justify-center;
  }

  ul > li {
    @apply block;
  }

  ul > li > a {
    @apply px-2;
    @apply py-1;
    @apply font-bold;
  }

  ul > li:not(:last-child) {
    border-right: 1px solid #ef9c57;
  }
}
</style>
